import React from 'react';
import {
    Alert,
    Grid,
    Paper,
} from "@mui/material";
import { paperStyles, loginStyles, alertTextStyles}  from './styles.js';

const InlineMessage = (props) => { 
  
  const { message } = props;
   return (
    <Grid>
      <Paper elevation={10} style={{ ...paperStyles, padding: '20px' }}>
        <Grid align="center">
          <img src="./logo.png" alt="logo" style={{ ...loginStyles, marginBottom: '20px' }} />

          {/* Ajustes aquí */}
          <Alert
            severity="info"
            sx={{
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              fontSize: '13px',
              textAlign: 'left',
              width: '100%',
              maxWidth: '100%',
            }}
          >
            {message}
          </Alert>
        </Grid>
      </Paper>
    </Grid>
  );
};
  
  export default InlineMessage;
  